// extracted by mini-css-extract-plugin
module.exports = {"container":"Vj6H9n4XVBe22AxqGg9Sw","sectionIcon":"_2p4v-lfkPBpO2TGP7goa-D","text":"_1Y64Ot8u2ksIEf0Bi8QN17"};